// src/helpers/mrt/getMRTDefaultProps.js
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

const DEFAULT_PAGINATION_OPTIONS = [5, 10, 15, 20, 25, 30, 40, 50, 100, 200];

function parsePaginationOptions(value) {
    if (Array.isArray(value)) {
        const options = value.map(Number).filter((item) => Number.isInteger(item) && item > 0);

        return options.length ? options : DEFAULT_PAGINATION_OPTIONS;
    }

    const options = String(value ?? '')
        .split(',')
        .map((item) => Number(item.trim()))
        .filter((item) => Number.isInteger(item) && item > 0);

    return options.length ? options : DEFAULT_PAGINATION_OPTIONS;
}

export function getMRTDefaultProps({ mrt, parametro, isMobile = false, rowSelectSize = 50 }) {
    /**
     * Define o pinning conforme o tamanho da tela.
     *
     * Essa configuração fica fora do initialState porque o initialState
     * só é aplicado quando a tabela é montada.
     *
     * Mantendo columnPinning dentro de state, o MRT recebe a nova
     * configuração quando a tela muda entre mobile e desktop.
     */
    const responsiveColumnPinning = isMobile
        ? {
              left: [],
              right: [],
          }
        : {
              left: ['mrt-row-actions', 'mrt-row-expand', 'mrt-row-select'],
              right: [],
          };
    return {
        enableColumnFilterModes: true,
        enableGlobalFilter: true,
        enableGlobalFilterModes: true,
        enableColumnOrdering: true,
        // No celular, desativa completamente o recurso
        enableColumnPinning: !isMobile,
        enableFacetedValues: true,

        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,

        enableDensityToggle: false,
        enableFullScreenToggle: false,
        /**
         * Não retorna automaticamente para a primeira página
         * quando alguma configuração estrutural da tabela muda,
         * como pinning ou breakpoint.
         */
        autoResetPageIndex: false,

        onColumnFiltersChange: mrt.setColumnFilters,
        onColumnFilterFnsChange: mrt.setColumnFiltersMode,
        onGlobalFilterChange: mrt.setGlobalFilter,
        onPaginationChange: mrt.setPagination,
        onSortingChange: mrt.setSorting,

        rowCount: mrt.rowCount,

        enableEditing: false,
        enableRowActions: true,
        enableRowSelection: true,

        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: 'Ações',
                size: isMobile ? 45 : 180,
                minSize: isMobile ? 45 : 180,
                maxSize: isMobile ? 45 : 250,
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                    sx: {
                        overflow: 'hidden',
                    },
                },
            },
            'mrt-row-numbers': {
                enableColumnOrdering: true,
                enableResizing: true,

                muiTableHeadCellProps: {
                    sx: {
                        fontSize: '1.2rem',
                    },
                },
            },
            'mrt-row-select': {
                enableColumnActions: true,
                enableHiding: true,
                size: rowSelectSize,
            },
        },
        state: {
            columnFilterFns: mrt.columnFilterFns,
            columnFilters: mrt.columnFilters,
            globalFilter: mrt.globalFilter,
            isLoading: mrt.isLoading,
            pagination: mrt.pagination,
            showAlertBanner: mrt.isError,
            showProgressBars: mrt.isRefetching,
            sorting: mrt.sorting,

            /**
             * Estado controlado para reagir imediatamente à mudança
             * entre mobile e desktop.
             */
            columnPinning: responsiveColumnPinning,
        },
        muiTablePaperProps: {
            elevation: 0,
        },
        muiToolbarAlertBannerProps: mrt.isError
            ? {
                  color: 'error',
                  children: 'Erro ao carregar os dados.',
              }
            : undefined,

        initialState: {
            showColumnFilters: true, //!isMobile,
            density: 'compact',

            columnPinning: isMobile
                ? {
                      left: [],
                      right: [],
                  }
                : {
                      left: ['mrt-row-actions', 'mrt-row-expand', 'mrt-row-select'],
                      right: [],
                  },
        },
        positionToolbarDropZone: 'bottom',
        positionExpandColumn: 'first',
        positionActionsColumn: 'first',
        positionToolbarAlertBanner: 'bottom',

        paginationDisplayMode: 'pages',

        muiPaginationProps: {
            color: 'secondary',
            rowsPerPageOptions: parsePaginationOptions(parametro?.paginacaoOptions),
            shape: 'rounded',
            variant: 'outlined',
        },

        localization: MRT_Localization_PT_BR,
    };
}
